import {
  isLoggedIn,
  getCurrentUser as getCurrentUserId
} from '@src/redux/modules/auth'

export default function redirectLoggedInUsers (store) {
  return (nextState, replace) => {
    const state = store.getState()

    const loggedIn = isLoggedIn(state)

    if (loggedIn) {
      const userId = getCurrentUserId(state)

      const { pathname, search } = nextState.location
      const pathnameWithoutSlash = pathname.slice(1)

      const next = `/perfil/${userId}/${pathnameWithoutSlash}${search}`

      replace(next)
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/middleware/redirectLoggedInUsers.js